import { colors } from '../../assets/colors';

type TwoLogoProps = {
    height?: string;
};

const TwoLogo = ({ height = '24' }: TwoLogoProps) => (
    <span
        style={{
            fontFamily: 'Gibson, sans-serif',
            fontWeight: 700,
            fontSize: height,
            lineHeight: 1,
            color: colors.dark,
            letterSpacing: '-0.02em',
            marginLeft: '5px'
        }}>
        two
    </span>
);

export default TwoLogo;
